import { Inject, Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { UnespCoreEnvironment } from '@unesp/core'
import { identity, Observable } from 'rxjs'
import { ErrorHandlerService } from './error-handler.service'

@Injectable({
  providedIn: 'root',
})
export class ConsultaLogService {
  private baseUrl: string

  constructor(
    private http: HttpClient,
    private errorHandlerService: ErrorHandlerService,
    @Inject('environment') env: UnespCoreEnvironment
  ) {
    this.baseUrl = env.baseUrlApi
  }

  listar(page = 0, size = 25, filtros: any): Observable<any> {
    return this.http
      .put<any>(`${this.baseUrl}/consulta-log`, filtros, {
        params: new HttpParams().set('page', page.toString()).set('size', size.toString()),
      })
      .pipe(identity, this.errorHandlerService.catchError())
  }
}
